import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Globe, AlertTriangle } from 'lucide-react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { Badge } from '../components/Badge';
const countries = [{
  name: 'Cina',
  code: 'CN',
  risk: 78,
  narrative: 'Nikel & Investasi',
  x: '70%',
  y: '38%'
}, {
  name: 'Rusia',
  code: 'RU',
  risk: 65,
  narrative: 'Anti-Barat & BRICS',
  x: '55%',
  y: '20%'
}, {
  name: 'AS',
  code: 'US',
  risk: 52,
  narrative: 'Demokrasi & HAM',
  x: '20%',
  y: '38%'
}, {
  name: 'Iran',
  code: 'IR',
  risk: 48,
  narrative: 'Geopolitik Timur Tengah',
  x: '60%',
  y: '40%'
}, {
  name: 'Singapura',
  code: 'SG',
  risk: 32,
  narrative: 'Ekonomi Regional',
  x: '68%',
  y: '60%'
}, {
  name: 'Australia',
  code: 'AU',
  risk: 28,
  narrative: 'Keamanan Pasifik',
  x: '78%',
  y: '78%'
}];
const attribution = [{
  narrative: 'Tuduhan KKN IKN',
  origin: 'Rusia (RT/Sputnik proxy)',
  amplifiers: '12 akun lokal',
  volume: '8.4K',
  risk: 'TINGGI'
}, {
  narrative: 'Anti-Hilirisasi Nikel',
  origin: 'Australia & UE NGO',
  amplifiers: 'Media lingkungan',
  volume: '14.2K',
  risk: 'SEDANG'
}, {
  narrative: 'Krisis Demokrasi Indonesia',
  origin: 'AS (think-tank)',
  amplifiers: 'Opini lokal',
  volume: '6.1K',
  risk: 'SEDANG'
}, {
  narrative: 'Konflik Papua',
  origin: 'NGO Eropa',
  amplifiers: 'Diaspora & media asing',
  volume: '11.0K',
  risk: 'TINGGI'
}, {
  narrative: 'Anti-BRICS Indonesia',
  origin: 'AS (state media)',
  amplifiers: 'Akademisi Barat',
  volume: '3.8K',
  risk: 'RENDAH'
}];
const outlets = [{
  name: 'RT (Russia Today)',
  country: 'Rusia',
  topics: 'BRICS, Anti-Barat, Geopolitik'
}, {
  name: 'CGTN',
  country: 'Cina',
  topics: 'Investasi, Hilirisasi, BRI'
}, {
  name: 'Sputnik Indonesia',
  country: 'Rusia',
  topics: 'Politik regional, Konflik'
}, {
  name: 'VOA Indonesia',
  country: 'AS',
  topics: 'Demokrasi, HAM, Kebijakan'
}, {
  name: 'ABC News Asia Pacific',
  country: 'Australia',
  topics: 'Papua, Lingkungan'
}, {
  name: 'Al Jazeera',
  country: 'Qatar',
  topics: 'Sosial, Konflik regional'
}];
export function ForeignInfluence() {
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1804">
      <PageHeader group="Intelijen Aktor" title="Foreign Influence Tracker" description="Pemantauan pengaruh asing terhadap narasi nasional — media negara, NGO, dan diaspora." icon={Globe} data-id="element-1805" />

      <Card className="bg-card border-border/50" data-id="element-1806">
        <CardContent className="p-4" data-id="element-1807">
          <div className="flex items-center justify-between mb-4" data-id="element-1808">
            <h3 className="font-heading text-sm font-bold" data-id="element-1809">
              Peta Operasi Pengaruh Asing
            </h3>
            <Badge variant="outline" className="font-mono text-[10px]" data-id="element-1810">
              LIVE TRACKING
            </Badge>
          </div>
          <div className="relative h-[300px] bg-muted/40 rounded border border-border/30 overflow-hidden" data-id="element-1811">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-1812"></div>

            {/* Mock Map Nodes */}
            {countries.map(c => <div key={c.code} className="absolute" style={{
            left: c.x,
            top: c.y,
            transform: 'translate(-50%, -50%)'
          }} data-id="element-1813">
                <div className={`relative size-8 rounded-full flex items-center justify-center border-2 ${c.risk >= 70 ? 'bg-red-500/30 border-red-500' : c.risk >= 50 ? 'bg-amber-500/30 border-amber-500' : 'bg-blue-500/30 border-blue-500'}`} data-id="element-1814">
                  <span className="font-mono text-[9px] font-bold" data-id="element-1815">
                    {c.code}
                  </span>
                  {c.risk >= 70 && <span className={`absolute inset-0 rounded-full bg-red-500/40 animate-ping`} data-id="element-1816" />}
                </div>
                <div className="absolute top-9 left-1/2 -translate-x-1/2 text-center whitespace-nowrap" data-id="element-1817">
                  <p className="font-mono text-[9px] font-bold" data-id="element-1818">{c.name}</p>
                  <p className="font-mono text-[8px] text-muted-foreground" data-id="element-1819">
                    Risk: {c.risk}
                  </p>
                </div>
              </div>)}
            {/* Indonesia marker */}
            <div className="absolute" style={{
            left: '70%',
            top: '55%'
          }} data-id="element-1820">
              <div className="size-3 rounded-full bg-emerald-500 border-2 border-white" data-id="element-1821" />
              <p className="font-mono text-[9px] font-bold text-emerald-500 mt-1" data-id="element-1822">
                INDONESIA
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-12 gap-4" data-id="element-1823">
        <Card className="col-span-12 lg:col-span-8 bg-card border-border/50" data-id="element-1824">
          <CardContent className="p-4" data-id="element-1825">
            <h3 className="font-heading text-sm font-bold mb-4" data-id="element-1826">
              Volume Narasi Asing vs Domestik
            </h3>
            <div className="space-y-2" data-id="element-1827">
              {attribution.map(a => <div key={a.narrative} className="p-3 rounded border border-border/50 bg-muted/20" data-id="element-1828">
                  <div className="flex items-center justify-between mb-1" data-id="element-1829">
                    <p className="text-xs font-bold" data-id="element-1830">{a.narrative}</p>
                    <Badge variant="outline" className={`font-mono text-[9px] ${a.risk === 'TINGGI' ? 'bg-red-500/10 text-red-500' : a.risk === 'SEDANG' ? 'bg-amber-500/10 text-amber-500' : 'bg-blue-500/10 text-blue-500'}`} data-id="element-1831">
                      {a.risk}
                    </Badge>
                  </div>
                  <div className="flex items-center justify-between text-[10px] text-muted-foreground" data-id="element-1832">
                    <span data-id="element-1833">{a.origin}</span>
                    <span data-id="element-1834">{a.volume}</span>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>

        <Card className="col-span-12 lg:col-span-4 bg-card border-border/50" data-id="element-1835">
          <CardContent className="p-4" data-id="element-1836">
            <h3 className="font-heading text-sm font-bold mb-4" data-id="element-1837">
              Top State-Sponsored Actors
            </h3>
            <div className="space-y-2" data-id="element-1838">
              {outlets.map(o => <div key={o.name} className="p-3 rounded border border-border/50 bg-muted/20" data-id="element-1839">
                  <div className="flex items-center justify-between mb-1" data-id="element-1840">
                    <p className="text-xs font-bold" data-id="element-1841">{o.name}</p>
                    <span className="font-mono text-[9px] text-muted-foreground" data-id="element-1842">
                      {o.country}
                    </span>
                  </div>
                  <p className="text-[10px] text-muted-foreground" data-id="element-1843">
                    {o.topics}
                  </p>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}